import math from "../../../screenassets/images/img/math.png";
import physics from "../../../screenassets/images/img/physics.webp";
import biology from "../../../screenassets/images/img/biology.jpg";
import dashboard from "../../../screenassets/images/img/dashboard.png";
import { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import NoData from "../../NoData";
import Loading from "../../Loading";
import { LuHardDriveUpload } from "react-icons/lu";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


export default function Banner() {

    const [search, setSearch] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const [subject, setSubject] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAll, setShowAll] = useState(false);
    const visibleSubjects = showAll ? subject : subject.slice(0, 5);
    const userDetails = useSelector((state) => state?.userSlice?.value);

    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!search && !selectedFile) {
            toast.info("This field is required!");
            return;
        }

        if (userDetails) {
            navigate("/user/dashboard", { state: { search: search, selectedFile: selectedFile } });
        } else {
            localStorage.setItem("homeSearch", search);

            if (selectedFile) {
                localStorage.setItem("homeFile", JSON.stringify(selectedFile));
                navigate("/signin");
            } else {
                navigate("/signin");
            }
        }

        setSearch("");
        setSelectedFile(null);
    };

    // Fetch All Subjects
    const fetchAllSubject = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service/getAllSubject`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.json();
    };

    useEffect(() => {
        fetchAllSubject().then((res) => {
            if (res.status) {
                setLoading(false);
                setSubject(res?.subjects);
            } else {
                toast.error("Failed to load subject. Please try again.");
            }
        }).catch((err) => {
            toast.error("Unable to fetch subject at the moment.");
        });
    }, []);



    const texts = [",answer.", ",result.", ",solution."]
    const period = 5000

    // useEffect(() => {
    //     var length = 0;
    //     var index = 1;
    //     var textGenerate = ''
    //     const interval = setInterval(() => {
    //         textGenerate = '';
    //         const textInterval = setInterval(() => {
    //             textGenerate = textGenerate + texts[index].charAt(length)
    //             if (texts[index].length == length) {
    //                 length = 0
    //                 clearInterval(textInterval);
    //                 texts.length - 1 == index ? index = 0 : index += 1
    //             } else {
    //                 length = Number(length + 1)
    //             }

    //             const textRotate = document.getElementById('txt-rotate');
    //             if (textRotate) {
    //                 textRotate.innerText = textGenerate ? textGenerate.split(",")[textGenerate.split(",").length - 1] : '';
    //             }

    //             //document.getElementById('txt-rotate').innerText = textGenerate ? textGenerate.split(",")[textGenerate.split(",").length - 1] : '';

    //         }, 200);
    //     }, period);
    //     return () => clearInterval(interval);
    // }, []);


    return (
        <>
            {/* Toast container */}
            < ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {loading ?
                <Loading />
                :
                <div className="rts-banner-area-one bg_image--1 bg_image rts-section-gap">
                    <div className="container mt--50">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="content-main-wrapper">
                                    {/* <h1 className="title">
                                    Codeulas AI Makes <br />  You
                                    <span className="txt-rotate" data-period="1000" data-rotate='["content.", "blog content.", "sales copy.", "media content."]'></span>
                                </h1> */}
                                    <h1 className="title" style={{ margin: "0.8em" }}>
                                        Ask. Learn. Get Board-Perfect {" "}
                                        <span className="txt-rotate">answer.</span>
                                        {/* <span className="txt-rotate" id="txt-rotate">answer.</span> */}
                                    </h1>
                                    <p className="disc">
                                        Instantly solve homework, board questions, and past papers with verified, step-by-step solutions in your own language — built for CBSE, ICSE, and State Boards.
                                    </p>

                                </div>
                            </div>

                            {/* <div className='col-sm-7' style={{ margin: "0px auto" }}>
                            <div className="two-rows user-area mb-4">
                                <button className="tag-btn purple">Hindi</button>
                                <button className="tag-btn purple">Borgoj</button>
                                <button className="tag-btn pink">Tent</button>
                                <button className="tag-btn orange">Teleyu</button>
                                <button className="tag-btn pink">Manash</button>
                                <button className="tag-btn green">Gupeci</button>
                                <button className="tag-btn blue">Kanoeda</button>
                                <button className="tag-btn blue">Melovitlm</button>
                                <button className="tag-btn light">Ofisi</button>
                                <button className="tag-btn blue">Pungila</button>
                                <button className="tag-btn blue">Uruvu</button>
                                <button className="tag-btn green">Urdu</button>
                                <button className="tag-btn light">English</button>
                            </div>
                        </div> */}

                            {/* <div className="col-sm-6 d-flex justify-content-center" style={{ margin: "0px auto" }}>
                            <div className="search-wrapper">
                                <input type="text" placeholder="Enter your question..." />
                                <button type="button">
                                    <IoSearch />
                                </button>
                            </div>
                        </div> */}

                            <div className="col-sm-12">

                                <div class="askbar" role="search" aria-label="Ask your question">
                                    <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M21 21l-4.3-4.3" stroke="#333" stroke-width="2" stroke-linecap="round" /><circle cx="11" cy="11" r="7" stroke="#333" stroke-width="2" /></svg>
                                    <input type="text" value={search} onChange={(event) => { setSearch(event.target.value) }} placeholder="Type your question or upload a photo…" aria-label="Your question" />
                                    <div class="actions">
                                        {/* <button class="iconbtn" title="Voice"><svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15a4 4 0 0 0 4-4V7a4 4 0 1 0-8 0v4a4 4 0 0 0 4 4Z" stroke="#333" stroke-width="2" /><path d="M5 11v1a7 7 0 0 0 14 0v-1" stroke="#333" stroke-width="2" stroke-linecap="round" /><path d="M12 19v3" stroke="#333" stroke-width="2" stroke-linecap="round" /></svg></button> */}
                                        <div class="iconbtn" id="uploadbtn">
                                            <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 3v12" stroke="#333" stroke-width="2" stroke-linecap="round" />
                                                <path d="M8 7l4-4 4 4" stroke="#333" stroke-width="2" stroke-linecap="round" />
                                                <rect x="4" y="15" width="16" height="6" rx="2" stroke="#333" stroke-width="2" />
                                            </svg>
                                            <input type="file" className="upload" onChange={(event) => setSelectedFile(event.target.files[0])} />
                                        </div>
                                        {/* <div class="iconbtn" title="Upload">
                                            <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 3v12" stroke="#333" stroke-width="2" stroke-linecap="round" />
                                                <path d="M8 7l4-4 4 4" stroke="#333" stroke-width="2" stroke-linecap="round" />
                                                <rect x="4" y="15" width="16" height="6" rx="2" stroke="#333" stroke-width="2" />
                                            </svg>
                                        </div> */}

                                        <button class="iconbtn" id="solveBtn" title="Solve now" onClick={(event) => { handleSubmit(event) }}><svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12h16" stroke="#333" stroke-width="2" stroke-linecap="round" /><path d="M13 5l7 7-7 7" stroke="#333" stroke-width="2" stroke-linecap="round" /></svg></button>
                                    </div>
                                </div>

                            </div>
                            {
                                subject.length > 0 ?
                                    <div className="col-sm-6 mt-5" style={{ margin: "0px auto" }}>
                                        <div className="d-flex justify-content-center flex-wrap">
                                            {visibleSubjects.map((sub, index) => {
                                                if (index < 5) {
                                                    return <div className="chip" key={index}>
                                                        {sub.subject}
                                                    </div>
                                                }
                                            })}

                                            {/* Show button only if more than 5 items */}
                                            {subject.length > 5 && (
                                                <div className="text-center mt-2 ms-4">
                                                    <button data-bs-toggle="modal" data-bs-target="#exampleModal" className="btn  btn-primary btn-sm" onClick={() => setShowAll(!showAll)} >
                                                        {showAll ? "View Less" : "View More"}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    :
                                    null
                            }

                            <div class="modal fade" id="exampleModal" tabindex="-1" data-bs-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content bg_image--1" style={{minHeight: "300px"}}>
                                        <div class="modal-header">
                                            <h1 class="modal-title fs-5" id="exampleModalLabel">All Subjects</h1>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setShowAll(!showAll) }}></button>
                                        </div>
                                        <div class="modal-body">
                                            <div className="col-sm-12 mt-5" style={{ margin: "0px auto" }}>
                                                <div className="d-flex justify-content-center flex-wrap">
                                                    {visibleSubjects.map((sub, index) => (
                                                        <div className="chip" key={index}>
                                                            {sub.subject}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>



                    <div className="bottom-mid-img">
                        <img src={dashboard} alt="banenr mimage" loading="lazy" />
                    </div>
                    <div className="usefull-for-ani">
                        <div className="single">
                            <img src={biology} alt="img" loading="lazy" style={{ width: "40px", borderRadius: "50%" }} />
                            <span>Biology</span>
                        </div>
                        <div className="single blog">
                            <img src={physics} alt="img" loading="lazy" style={{ width: "40px", borderRadius: "50%" }} />
                            <span>Physics</span>
                        </div>
                        <div className="single copy">
                            <img src={math} alt="img" loading="lazy" style={{ width: "40px", borderRadius: "50%" }} />
                            <span>Math</span>
                        </div>
                        {/* <div className="single freelancer">
                        <img src={chemistry} alt="img" loading="lazy" style={{ width: "40px", borderRadius: "50%" }} />
                        <span>Chemistry </span>
                    </div> */}
                    </div>
                </div>
            }
        </>
    )
}
